module.exports = __webpack_public_path__ + "static/media/sl.db3557fb.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sl.svg
// module id = 2209
// module chunks = 0